import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BigPicklistInput } from 'Packages/FacetDesign/Components';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'lg' },
  }, overrideReadOnly)
  .typeOverride('picklist', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly);
